import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'components/atoms'
import * as S from './styled'

/**
  Uso:
    const handleButtonClick = () =>{
      console.log('click')
    }

  <Button
    label={'Back'} -> texto a mostrar
    classBtn={'back'} -> tipo [default, primary, secondary, delete, exit, close, back, icon, icon-multi, back-alter, info, logout]
    handleClick={() => handleButtonClick()} -> función al hacer click
    icon={BackIcon} -> Source del icono (por defecto undefined)
    isDisabled={true} -> Botón deshabilitado
    iconLeft -> Icono a la izquierda (por defecto a la derecha)
  />
 */

const Button = ({
  label,
  classBtn,
  handleClick,
  icon,
  iconWidth,
  iconHeight,
  isDisabled,
  iconLeft,
  width,
  important,
  fontSize,
  fontWeight,
  selected,
}) => {
  return (
    <S.ButtonContainer
      isDisabled={isDisabled}
      iconLeft={iconLeft}
      width={width}
      icon={icon}
      important={important}
      fontSize={fontSize}
      fontWeight={fontWeight}
      selected={selected}
    >
      <button
        className={classBtn ? `btn btn-${classBtn}` : 'btn btn-default'}
        onClick={!isDisabled ? handleClick : null}
        type='button'
      >
        <p>{label}</p>
        {icon && <Icon Source={icon} width={iconWidth} height={iconHeight} />}
      </button>
    </S.ButtonContainer>
  )
}

Button.defaultProps = {
  label: '',
  classBtn: 'default',
  handleClick: () => {},
  icon: null,
  iconWidth: '18px',
  iconHeight: '14px',
  isDisabled: false,
  iconLeft: false,
  width: null,
  important: true,
  fontSize: '',
  fontWeight: '',
  selected: false,
}

Button.propTypes = {
  label: PropTypes.string,
  classBtn: PropTypes.string,
  handleClick: PropTypes.func,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  iconWidth: PropTypes.string,
  iconHeight: PropTypes.string,
  isDisabled: PropTypes.bool,
  iconLeft: PropTypes.bool,
  width: PropTypes.string,
  important: PropTypes.bool,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  selected: PropTypes.bool,
}

export default Button
